import { useCallback } from "react";

import type { LayerDefinition } from "../../../models/mapConfiguration";

import { sharedEnrollmentLayerIds } from "../layers/dateRange";
import { applyFilterChange } from "../layers/layer";
import { useMapLayers } from "../layers/layerContext";
import { useLayerLookups } from "./useLayerLookups";

export type UpdateLayerFilter = (value: unknown, name: keyof LayerDefinition) => void;

export interface LayerFilterProps {
	layer: LayerDefinition;
	updateFilter: UpdateLayerFilter;
}

export function useUpdateLayerFilter(layerId: string) {
	const { layers, updateLayer } = useMapLayers();
	const layer = layers.get(layerId);
	const lookup = useLayerLookups(layer?.partnerTypeId);
	// Joined into a string so updateFilter keeps its identity while the other layers change.
	const enrollmentLayerIds = sharedEnrollmentLayerIds(layers.data, layerId).join("\n");

	const updateFilter = useCallback<UpdateLayerFilter>(
		(value, name) => {
			const ids = name === "enrollmentId" ? enrollmentLayerIds.split("\n") : [layerId];
			for (const id of ids) updateLayer(id, (current) => applyFilterChange(current, name, value, lookup));
		},
		[enrollmentLayerIds, layerId, lookup, updateLayer],
	);

	return { layer, updateFilter };
}
